import { render, staticRenderFns } from "./AuthorizationCodeBinding.vue?vue&type=template&id=1478fe1c&scoped=true"
import script from "./AuthorizationCodeBinding.vue?vue&type=script&lang=js"
export * from "./AuthorizationCodeBinding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1478fe1c",
  null
  
)

export default component.exports